export async function requestPersistentStorage(): Promise<boolean> {
  try {
    if (typeof navigator !== 'undefined' && navigator.storage?.persist) {
      return await navigator.storage.persist();
    }
  } catch {
    return false;
  }
  return false;
}

export function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const media = window.matchMedia?.('(display-mode: standalone)');
  if (media?.matches) {
    return true;
  }
  const nav = navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true;
}

export function isIosSafari(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent;
  const isIosDevice = /iPad|iPhone|iPod/u.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  if (!isIosDevice) {
    return false;
  }
  // Не считаем кроссплатформенные WebView/Chrome/Firefox на iOS за Safari-инсталляцию.
  return !/CriOS|FxiOS|EdgiOS|OPiOS/u.test(ua);
}
